import styled from "styled-components";

export const IllustrationContainer = styled.div`
  position: relative;
  display: grid;
  place-content: center;
  height: 150px;
  width: 230px;
  border-radius: 10px;
  background: url(${({ illustration }) => illustration});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.1);

  svg {
    z-index: 1;
  }

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 15px;
  }
`;

export const IllustrationsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
`;

export const IllustrationPreviewContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
`;
